import { render, staticRenderFns } from "./CommunityInfrastructure.vue?vue&type=template&id=5e024499&scoped=true&"
import script from "./CommunityInfrastructure.vue?vue&type=script&lang=js&"
export * from "./CommunityInfrastructure.vue?vue&type=script&lang=js&"
import style0 from "./CommunityInfrastructure.vue?vue&type=style&index=0&id=5e024499&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e024499",
  null
  
)

export default component.exports